/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo, useRef } from "react";
import { bem } from "../shared/BEM";
import { IButtonProps, Button } from "./Button";

/**
 * Component props
 */
export interface IButtonSaveProps extends IButtonProps {
	doSave: () => {
		url: string;
		data: any;
	};
}

/**
 * Save Button component
 *
 * @param props Component props
 */
export function ButtonSave(props: IButtonSaveProps) {

	const formRef = useRef(null);
	const inputRef = useRef(null);

	const handleClick = useMemo(() => () => {

		const saveData = props.doSave();

		const formEl = formRef.current as HTMLFormElement;
		const inputEl = inputRef.current as HTMLInputElement;

		inputEl.value = JSON.stringify(saveData.data);
		formEl.action = saveData.url;

		formEl.submit();

		if (props.onClick) {
			props.onClick();
		}

	}, [ props.doSave ]);

	return <Button
		{...props}
		onClick={handleClick}
		renderCustom={() =>
			<form method="post" ref={formRef} target="_blank">
				<input type="hidden" name="data" value="" ref={inputRef} />
			</form>
		}
	/>;

}
